import Dialog from "components/ui/Dialog/Dialog";
import Trans from "features/translation/components/Trans";
import Button from "components/ui/Button/Button";
import { useDialog } from "context/DialogContext";

const CommentCreateUpdateNotAllowed = () => {
  const { hideDialog } = useDialog();

  return (
    <Dialog title={ `U bent nog geen lid van deze groep` }>
      <div className={ `dialog__row`}>
        <Trans text={ `U kunt niet op dit bericht reageren omdat u nog geen lid bent van de groep, ga naar de groepspagina om lid te worden.` }/>
      </div>
      <div className="dialog__buttons dialog__buttons--end">
        <Button variant={ `secondary` } onClick={ () => hideDialog() }>Sluiten</Button>
      </div>
    </Dialog>
  )
}

export default CommentCreateUpdateNotAllowed;
